export default "__VITE_ASSET__DaVqQojM__"